import script from "./pageTeamLeague.vue?vue&type=script&setup=true&lang=js"
export * from "./pageTeamLeague.vue?vue&type=script&setup=true&lang=js"

import "./pageTeamLeague.vue?vue&type=style&index=0&id=02f3d23e&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02f3d23e"]])

export default __exports__